<template>
    <Breadcrumbs main="Apps" title="Projects" />
    <div class="container-fluid">
        <div class="email-wrap bookmark-wrap">
            <div class="row">
                <contactSildebar />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const contactSildebar = defineAsyncComponent(() => import("@/components/projects/list.vue"))
</script>